import NewAskiDashboard from './NewAskiDashboard';

const AskiDashboard = () => {
  return <NewAskiDashboard />;
};

export default AskiDashboard;
